import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const KEY = "kazyoni_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (item) => setItems((p) => [...p, item]);
  const remove = (idx) => setItems((p) => p.filter((_, i) => i !== idx));
  const clear = () => setItems([]);
  const count = items.length;
  const total = items.reduce((s, i) => s + i.unitPrice * i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, clear, count, total }}>
      {children}
    </CartCtx.Provider>
  );
}
